export function numVal(
  value: string | number | null | undefined | boolean | Array<unknown> | Record<string, unknown>,
  isFloat = false
): number {
  if (value === null || value === undefined) {
    return 0
  }

  if (Array.isArray(value)) {
    return value.length
  }

  if (typeof value === 'object') {
    return 0
  }

  // Handle non-finite numbers (NaN, Infinity, -Infinity)
  if (typeof value === 'number') {
    if (!Number.isFinite(value)) {
      return 0
    }

    // Convert to integer, handling decimals
    return isFloat ? value : Math.trunc(value)
  }

  // Handle string values
  const stringValue = String(value).trim()

  // Handle empty strings
  if (stringValue === '') {
    return 0
  }

  // Parse as integer
  const parsed = isFloat ? Number.parseFloat(stringValue) : Number.parseInt(stringValue, 10)

  // Check if parsing resulted in NaN
  if (Number.isNaN(parsed)) {
    return 0
  }

  // Check if the parsed value is finite
  if (!Number.isFinite(parsed)) {
    return 0
  }

  return parsed
}

export function isFloat(value: number): boolean {
  return !Number.isInteger(value)
}
